module.exports = {"name":true}


//////////////////
// WEBPACK FOOTER
// ./src/schemas/filters/schedules.json
// module id = We36
// module chunks = 1